import { ActionHandler } from 'action-handler';
import { fetchInstalledInterval } from 'config';

export default new ActionHandler({
  name: 'set_sync_interval',
  defaultState: {
    syncInterval: fetchInstalledInterval
  },
  handler(syncInterval) {
    return {
      syncInterval
    };
  },
  reduce(state, { syncInterval }) {
    return {
      syncInterval
    };
  }
});
